import { useEffect } from "react";

/**
 * Sets the document <title> and the primary meta description for the current
 * page. Falls back to sensible defaults from BRAND.
 *
 * Usage:
 *   useMeta({
 *     title: "Sample Listings | LotWise Auto",
 *     description: "Before / after proof of the LotWise Auto standard..."
 *   });
 */
export function useMeta({ title, description, canonicalPath, robots }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);

      // og:description mirrors the description
      let og = document.querySelector('meta[property="og:description"]');
      if (!og) {
        og = document.createElement("meta");
        og.setAttribute("property", "og:description");
        document.head.appendChild(og);
      }
      og.setAttribute("content", description);
    }

    if (title) {
      let ogt = document.querySelector('meta[property="og:title"]');
      if (!ogt) {
        ogt = document.createElement("meta");
        ogt.setAttribute("property", "og:title");
        document.head.appendChild(ogt);
      }
      ogt.setAttribute("content", title);
    }

    if (canonicalPath) {
      const href = `${window.location.origin}${canonicalPath}`;
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", href);

      let ogu = document.querySelector('meta[property="og:url"]');
      if (!ogu) {
        ogu = document.createElement("meta");
        ogu.setAttribute("property", "og:url");
        document.head.appendChild(ogu);
      }
      ogu.setAttribute("content", href);
    }

    // Robots directive (e.g., "noindex, follow" for internal-facing pages).
    let robotsTag = document.querySelector('meta[name="robots"]');
    if (robots) {
      if (!robotsTag) {
        robotsTag = document.createElement("meta");
        robotsTag.setAttribute("name", "robots");
        document.head.appendChild(robotsTag);
      }
      robotsTag.setAttribute("content", robots);
    } else if (robotsTag) {
      // Reset to default indexable state when leaving a noindex page.
      robotsTag.setAttribute("content", "index, follow");
    }
  }, [title, description, canonicalPath, robots]);
}
